import { useState } from 'react';
import { recordConsent } from '../consentApi';
import '../consent.css';

type ConsentScreenProps = {
  onConsented: () => void;
  onCancel: () => void;
};

export function ConsentScreen({ onConsented, onCancel }: ConsentScreenProps) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const consent = async () => {
    setSubmitting(true);
    setError(null);

    try {
      await recordConsent();
      onConsented();
    } catch {
      setError('Не удалось сохранить согласие. Попробуйте ещё раз.');
      setSubmitting(false);
    }
  };

  return (
    <div className="scanner-sheet scanner-sheet--centered consent-screen">
      <span className="scanner-kicker">Перед первым сканированием</span>
      <h2>Согласие с политикой конфиденциальности</h2>
      <p>
        Мы обрабатываем данные чеков для подтверждения визитов и начисления XP.
        {' '}
        <a href="/privacy-policy" target="_blank" rel="noreferrer">Подробнее в политике конфиденциальности</a>.
      </p>

      <div className="consent-summary">
        <strong>Коротко</strong>
        <span>Чек нужен, чтобы подтвердить реальный визит.</span>
        <span>Сырые данные провайдера автоматически очищаются по сроку хранения.</span>
        <span>Согласие можно отозвать в профиле.</span>
      </div>

      {error && <div className="consent-error" role="alert">{error}</div>}

      <button className="scanner-primary-button" type="button" disabled={submitting} onClick={() => void consent()}>
        {submitting ? 'Сохраняем…' : 'Согласен'}
      </button>
      <button className="scanner-text-button" type="button" disabled={submitting} onClick={onCancel}>
        Отмена
      </button>
    </div>
  );
}
